import { render } from "./ColoredSelect.vue?vue&type=template&id=4f545d74&ts=true"
import script from "./ColoredSelect.vue?vue&type=script&lang=ts"
export * from "./ColoredSelect.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__